import axios from '@/libs/api.request'
var qs = require('qs');
// 获取列表数据
export const fetchTableList = (params) => {
    let data = params
    data = qs.stringify(data)
    return axios.request({
        url: '/student/student-list',
        data,
        method: 'post'
    })
};
// 改变状态
export const setStatus = (params) => {
    let data = params;
    data = qs.stringify(data);
    return axios.request({
        url: 'student/student-status',
        data,
        method: 'post'
    })
};
// 新增修改
export const addModify = (params) => {
    let data = params;
    data = qs.stringify(data);
    return axios.request({
        url: 'student/student-update',
        data,
        method: 'post'
    })
};
// 获取详情
export const fetchInfo = (params) => {
    let data = params;
    data = qs.stringify(data);
    return axios.request({
        url: '/student/student-info',
        data,
        method: 'post'
    })
};